export default __webpack_public_path__ + "static/media/nutritionGuideFilterHeadings.77ae6dfa.png";